module.exports = __webpack_public_path__ + "static/media/cwiczenie_3.8cb1c5f5.jpg";